export default __webpack_public_path__ + "static/media/val4.cda22caf.png";